import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createNoticeSetting } from '../../../../store/actions/actions';
import moment from 'moment';
import { DatePicker, Form } from 'antd';
import periodSettings from '../../../../constants/periodSettings';
import dateStartNamesForTypes from '../../../../constants/dateStartNamesForTypes';
import './CreateNotice.scss';

const DefaultDatePicker = ({ type }) => {
  const dispatch = useDispatch();

  const dateStartKey = dateStartNamesForTypes[type];

  const commonStart = useSelector((store) => {
    return store.debtsStore.createNotice.start;
  });
  const start = useSelector(
    (store) => store.debtsStore.createNotice[dateStartKey]
  );

  const onDateStartChange = useCallback(
    (e) => {
      dispatch(createNoticeSetting({ [dateStartKey]: moment(e) }));
    },
    [dateStartKey]
  );

  useEffect(() => {
    if (!start) {
      dispatch(createNoticeSetting({ [dateStartKey]: moment(commonStart) }));
    }
  }, [commonStart, start]);
  const onDateChange = useCallback(
    (e) => onDateStartChange(e),
    [onDateStartChange]
  );
  return (
    <Form.Item label="Старт оповещения" colon={false}>
      <DatePicker
        disabled={start} // Пока не настраивается отдельно время для каждого типа
        {...periodSettings}
        onChange={onDateChange}
        value={start || commonStart}
      />
    </Form.Item>
  );
};

export default DefaultDatePicker;
